import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import { Card, CardBody, CardHeader } from '@progress/kendo-react-layout';
import '@progress/kendo-theme-default/dist/all.css';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUserContext } from '../../../context/UserContext';
import AutoDapLogo from "../../../images/logo/autodap.png";
import { login } from '../../../services/login-service/loginService';
import LoaderOverlay from '../../custom-loader/LoaderOverlay';


const LoginComponent = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState('');
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { setUser, updatedUserData } = useUserContext()

    function isValidEmail(email) {
        return emailRegex.test(email);
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true)
        let emailLowercase = email.toLowerCase()?.trim()
        const isLogin = await login(emailLowercase, password)
        if (isLogin?.status === 200 && isLogin?.User) {
            let userData = isLogin?.User || {};
            setUser(userData)
            localStorage.removeItem("chat_id");
            localStorage.removeItem("currentChats");
            localStorage.removeItem("selectedParts");
            if (userData?.Is_FirstPasswordChanged && userData?.Is_FirstPasswordChanged === 1) {
                let homeRoute = userData?.routes[0]?.route || "/"
                navigate(homeRoute)
                setLoading(false)

                return;
            }
            else {
                if (userData && userData?.Token) {
                    const token = userData.Token
                    const resetUrl = `/reset-password/${token}`;
                    navigate(resetUrl)
                    setLoading(false)
                    return;
                }
                setLoading(false)
                return;
            }
            // setLoading(false)
            // navigate('/verification')
            // setEmail("")
            // setPassword("")
            // return;
        }
        else if (isLogin?.status === 401) {
            toast.error(isLogin.message);
        }
        else {
            toast.error("Please try again later");
        }
        setLoading(false)
    };
    const togglePasswordVisibility = () => {
        setShowPassword((prevVisibility) => !prevVisibility);
    }

    return (
        <div className="login-card-container">
            <LoaderOverlay loading={loading} />
            <Card className="custom-login-card">
                <CardHeader>
                    <img src={AutoDapLogo} alt='autodap' style={{ height: "100%", width: "100%" }} />
                </CardHeader>
                <form onSubmit={handleLogin} className="login-form">
                    <CardBody className="login-form">
                        <div className="input-group">
                            <label className='custom-label'>Email</label>
                            <Input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="k-textbox custom-input"
                                placeholder="Email"
                                autoComplete='current-email'
                            />
                        </div>

                        <div className="input-group">
                            <label className='custom-label'>Password</label>
                            <Input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="k-textbox custom-input"
                                placeholder="Password"
                                autoComplete="current-password"
                            />
                            <button type='button' className='toggle-password' onClick={togglePasswordVisibility}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        <div>
                            <Button
                                type="submit"
                                color='primary'
                                className="k-button custom-button"
                                disabled={!isValidEmail(email) || !password}
                                onClick={handleLogin}
                            >
                                Sign in
                            </Button>
                        </div>
                    </CardBody>
                </form>
            </Card>
        </div>
    );
};

export default LoginComponent;
